"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetsApi = void 0;
var runtime = require("../runtime");
var index_1 = require("../models/index");
/**
 *
 */
var AssetsApi = /** @class */ (function (_super) {
    __extends(AssetsApi, _super);
    function AssetsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Archive or unarchive a set of asset IDs.
     * Archive or unarchive assets
     */
    AssetsApi.prototype.bulkUpdateAssetsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling bulkUpdateAssets.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/assets".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.BulkUpdateAssetsRequestToJSON)(requestParameters.bulkUpdateAssetsRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BulkUpdateAssetsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Archive or unarchive a set of asset IDs.
     * Archive or unarchive assets
     */
    AssetsApi.prototype.bulkUpdateAssets = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bulkUpdateAssetsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Completes the upload session of a chunked asset. Asset type can be either image, audio, or video.
     * Complete Upload Chunked Asset
     */
    AssetsApi.prototype.completeUploadChunkedAssetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling completeUploadChunkedAsset.');
                        }
                        if (requestParameters.assetId === null || requestParameters.assetId === undefined) {
                            throw new runtime.RequiredError('assetId', 'Required parameter requestParameters.assetId was null or undefined when calling completeUploadChunkedAsset.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/assets/{asset_id}/chunked_upload/complete".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("asset_id", "}"), encodeURIComponent(String(requestParameters.assetId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.ChunkedUploadCompleteToJSON)(requestParameters.chunkedUploadComplete),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AssetResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Completes the upload session of a chunked asset. Asset type can be either image, audio, or video.
     * Complete Upload Chunked Asset
     */
    AssetsApi.prototype.completeUploadChunkedAsset = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.completeUploadChunkedAssetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Determine if content violates any content moderation policies and return a list of violations.
     * Determine if text violates any content moderation policies.
     */
    AssetsApi.prototype.contentModerationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling contentModeration.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/mfe/ad_accounts/{ad_account_id}/moderation".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.ContentModerationRequestToJSON)(requestParameters.contentModerationRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ContentModerationResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Determine if content violates any content moderation policies and return a list of violations.
     * Determine if text violates any content moderation policies.
     */
    AssetsApi.prototype.contentModeration = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contentModerationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates an asset belonging to provided ad account and returns asset metadata. Asset type can be either image, audio, or video.
     * Create Asset
     */
    AssetsApi.prototype.createAssetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling createAsset.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/assets".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreateAssetRequestToJSON)(requestParameters.createAssetRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AssetResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates an asset belonging to provided ad account and returns asset metadata. Asset type can be either image, audio, or video.
     * Create Asset
     */
    AssetsApi.prototype.createAsset = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createAssetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates an asset belonging to provided ad account and returns a signed gcs url. Asset type can be either image, audio, or video.
     * Create Asset And Get Upload Url.
     */
    AssetsApi.prototype.createAssetAndGetUploadUrlRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling createAssetAndGetUploadUrl.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/assets/upload_url".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreateAssetAndGetUploadUrlRequestToJSON)(requestParameters.createAssetAndGetUploadUrlRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CreateAssetAndGetUploadUrlResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates an asset belonging to provided ad account and returns a signed gcs url. Asset type can be either image, audio, or video.
     * Create Asset And Get Upload Url.
     */
    AssetsApi.prototype.createAssetAndGetUploadUrl = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createAssetAndGetUploadUrlRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a file belonging to provided ad account and returns a signed gcs url. These files will not be validated or processed.
     * Create file.
     */
    AssetsApi.prototype.createFileRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling createFile.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/files/upload_url".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreateFileRequestToJSON)(requestParameters.createFileRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CreateAssetAndGetUploadUrlResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a file belonging to provided ad account and returns a signed gcs url. These files will not be validated or processed.
     * Create file.
     */
    AssetsApi.prototype.createFile = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createFileRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Given a voiceover track and an optional background music track, combine into a single audio file.
     * Create a temporary mix preview from a voiceover and optional background track. To save, call createAsset
     */
    AssetsApi.prototype.generateMixPreviewRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling generateMixPreview.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/mfe/ad_accounts/{ad_account_id}/previews/mix".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.GenerateMixPreviewRequestToJSON)(requestParameters.generateMixPreviewRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GenerateMixPreviewResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Given a voiceover track and an optional background music track, combine into a single audio file.
     * Create a temporary mix preview from a voiceover and optional background track. To save, call createAsset
     */
    AssetsApi.prototype.generateMixPreview = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.generateMixPreviewRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Given a talking points, a tone, a voiceover profile, and a background track, make a mix
     * Generate Mixed Voiceover Preview
     */
    AssetsApi.prototype.generateMixedVoiceoverRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/previews/mixed_voiceover",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.GenerateMixedVoiceoverRequestToJSON)(requestParameters.generateMixedVoiceoverRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GenerateMixedVoiceoverResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Given a talking points, a tone, a voiceover profile, and a background track, make a mix
     * Generate Mixed Voiceover Preview
     */
    AssetsApi.prototype.generateMixedVoiceover = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.generateMixedVoiceoverRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Given advertiser information and the desired number of scripts, generate a set of scripts to be used for a voiceover.
     * Generate Scripts
     */
    AssetsApi.prototype.generateScriptsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling generateScripts.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/mfe/ad_accounts/{ad_account_id}/previews/script".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.GenScriptsRequestToJSON)(requestParameters.genScriptsRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GenScriptsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Given advertiser information and the desired number of scripts, generate a set of scripts to be used for a voiceover.
     * Generate Scripts
     */
    AssetsApi.prototype.generateScripts = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.generateScriptsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Given a transcript and desired voice characteristics, return a url containing the generated voiceover and a unique identifier.
     * Generate Voiceover Preview
     */
    AssetsApi.prototype.generateVoiceoverPreviewRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling generateVoiceoverPreview.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/mfe/ad_accounts/{ad_account_id}/previews/voiceover".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.GenerateVoiceoverPreviewRequestToJSON)(requestParameters.generateVoiceoverPreviewRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.VoiceoverPreviewFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Given a transcript and desired voice characteristics, return a url containing the generated voiceover and a unique identifier.
     * Generate Voiceover Preview
     */
    AssetsApi.prototype.generateVoiceoverPreview = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.generateVoiceoverPreviewRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns asset metadata for a given asset ID.
     * Get Asset by ID
     */
    AssetsApi.prototype.getAssetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getAsset.');
                        }
                        if (requestParameters.assetId === null || requestParameters.assetId === undefined) {
                            throw new runtime.RequiredError('assetId', 'Required parameter requestParameters.assetId was null or undefined when calling getAsset.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/assets/{asset_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("asset_id", "}"), encodeURIComponent(String(requestParameters.assetId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AssetResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns asset metadata for a given asset ID.
     * Get Asset by ID
     */
    AssetsApi.prototype.getAsset = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAssetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns list of asset metadata in descending order via the creation time within each asset type for a given ad account ID.
     * Get Assets by Ad Account
     */
    AssetsApi.prototype.getAssetsByAdAccountRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getAssetsByAdAccount.');
                        }
                        queryParameters = {};
                        if (requestParameters.assetIds) {
                            queryParameters['asset_ids'] = requestParameters.assetIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.assetTypes) {
                            queryParameters['asset_types'] = Array.from(requestParameters.assetTypes).join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.assetSubtypes) {
                            queryParameters['asset_subtypes'] = Array.from(requestParameters.assetSubtypes).join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.libraryAvailability !== undefined) {
                            queryParameters['library_availability'] = requestParameters.libraryAvailability;
                        }
                        if (requestParameters.statuses) {
                            queryParameters['statuses'] = Array.from(requestParameters.statuses).join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.approvalState !== undefined) {
                            queryParameters['approval_state'] = requestParameters.approvalState;
                        }
                        if (requestParameters.aspectRatios) {
                            queryParameters['aspect_ratios'] = Array.from(requestParameters.aspectRatios).join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.name !== undefined) {
                            queryParameters['name'] = requestParameters.name;
                        }
                        if (requestParameters.createdAtStartDate !== undefined) {
                            queryParameters['created_at_start_date'] = requestParameters.createdAtStartDate.toISOString();
                        }
                        if (requestParameters.createdAtEndDate !== undefined) {
                            queryParameters['created_at_end_date'] = requestParameters.createdAtEndDate.toISOString();
                        }
                        if (requestParameters.predefinedFilter !== undefined) {
                            queryParameters['predefined_filter'] = requestParameters.predefinedFilter;
                        }
                        if (requestParameters.sortDirection !== undefined) {
                            queryParameters['sort_direction'] = requestParameters.sortDirection;
                        }
                        if (requestParameters.sortField !== undefined) {
                            queryParameters['sort_field'] = requestParameters.sortField;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/assets".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AssetsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns list of asset metadata in descending order via the creation time within each asset type for a given ad account ID.
     * Get Assets by Ad Account
     */
    AssetsApi.prototype.getAssetsByAdAccount = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAssetsByAdAccountRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns list of all stock assets of the specified type.
     * Get Stock Assets
     */
    AssetsApi.prototype.getStockAssetsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.assetType === null || requestParameters.assetType === undefined) {
                            throw new runtime.RequiredError('assetType', 'Required parameter requestParameters.assetType was null or undefined when calling getStockAssets.');
                        }
                        queryParameters = {};
                        if (requestParameters.assetType !== undefined) {
                            queryParameters['asset_type'] = requestParameters.assetType;
                        }
                        if (requestParameters.backgroundMusicVendorUpdate !== undefined) {
                            queryParameters['background_music_vendor_update'] = requestParameters.backgroundMusicVendorUpdate;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/stock/assets",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.StockAssetsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns list of all stock assets of the specified type.
     * Get Stock Assets
     */
    AssetsApi.prototype.getStockAssets = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getStockAssetsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Given optional inputs of language and provider type, return the corresponding available voice profiles to be used to create a voiceover asset.
     * Get Voice Profiles
     */
    AssetsApi.prototype.getVoiceProfilesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/mfe/voice_profiles",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.GetVoiceProfilesRequestToJSON)(requestParameters.getVoiceProfilesRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetVoiceProfilesResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Given optional inputs of language and provider type, return the corresponding available voice profiles to be used to create a voiceover asset.
     * Get Voice Profiles
     */
    AssetsApi.prototype.getVoiceProfiles = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVoiceProfilesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Given optional inputs of language and provider type, return the corresponding available voice profiles to be used to create a voiceover asset.
     * Get Asset by ID
     */
    AssetsApi.prototype.getVoiceProfilesWithFiltersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.voiceProfileId !== undefined) {
                            queryParameters['voice_profile_id'] = requestParameters.voiceProfileId;
                        }
                        if (requestParameters.language !== undefined) {
                            queryParameters['language'] = requestParameters.language;
                        }
                        if (requestParameters.providerType !== undefined) {
                            queryParameters['provider_type'] = requestParameters.providerType;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/mfe/voice_profiles",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetVoiceProfilesResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Given optional inputs of language and provider type, return the corresponding available voice profiles to be used to create a voiceover asset.
     * Get Asset by ID
     */
    AssetsApi.prototype.getVoiceProfilesWithFilters = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVoiceProfilesWithFiltersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Copy asset from url. This is an alternative to upload.
     * Internal route for ingesting assets that have already been transcoded by external systems.
     */
    AssetsApi.prototype.ingestAssetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling ingestAsset.');
                        }
                        if (requestParameters.assetId === null || requestParameters.assetId === undefined) {
                            throw new runtime.RequiredError('assetId', 'Required parameter requestParameters.assetId was null or undefined when calling ingestAsset.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/assets/{asset_id}/ingest".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("asset_id", "}"), encodeURIComponent(String(requestParameters.assetId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.IngestAssetRequestToJSON)(requestParameters.ingestAssetRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AssetResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Copy asset from url. This is an alternative to upload.
     * Internal route for ingesting assets that have already been transcoded by external systems.
     */
    AssetsApi.prototype.ingestAsset = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ingestAssetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * When asset is uploaded directly to storage by client, it must call this route post-upload to trigger processing of the asset.
     * Register uploaded asset
     */
    AssetsApi.prototype.registerAssetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling registerAsset.');
                        }
                        if (requestParameters.assetId === null || requestParameters.assetId === undefined) {
                            throw new runtime.RequiredError('assetId', 'Required parameter requestParameters.assetId was null or undefined when calling registerAsset.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/assets/{asset_id}/register".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("asset_id", "}"), encodeURIComponent(String(requestParameters.assetId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.RegisterAssetRequestToJSON)(requestParameters.registerAssetRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AssetResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * When asset is uploaded directly to storage by client, it must call this route post-upload to trigger processing of the asset.
     * Register uploaded asset
     */
    AssetsApi.prototype.registerAsset = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.registerAssetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Start a chunked asset upload process and retrieve upload session id. Asset type can be image, audio, or video. Client is expected to use max_chunk_size_mb in the response to dynamically determine how big each file chunk should be.
     * Start Upload Chunked Asset
     */
    AssetsApi.prototype.startUploadChunkedAssetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling startUploadChunkedAsset.');
                        }
                        if (requestParameters.assetId === null || requestParameters.assetId === undefined) {
                            throw new runtime.RequiredError('assetId', 'Required parameter requestParameters.assetId was null or undefined when calling startUploadChunkedAsset.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/assets/{asset_id}/chunked_upload/start".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("asset_id", "}"), encodeURIComponent(String(requestParameters.assetId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ChunkedUploadSessionFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Start a chunked asset upload process and retrieve upload session id. Asset type can be image, audio, or video. Client is expected to use max_chunk_size_mb in the response to dynamically determine how big each file chunk should be.
     * Start Upload Chunked Asset
     */
    AssetsApi.prototype.startUploadChunkedAsset = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.startUploadChunkedAssetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Continues the upload session of a chunked asset by transferring one section of binary media data. Supports uploads of file chunks up to 20MB in size. Asset type can be either image, audio, or video.
     * Transfer Chunked Asset
     */
    AssetsApi.prototype.transferChunkedAssetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, consumes, canConsumeForm, formParams, useForm, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling transferChunkedAsset.');
                        }
                        if (requestParameters.assetId === null || requestParameters.assetId === undefined) {
                            throw new runtime.RequiredError('assetId', 'Required parameter requestParameters.assetId was null or undefined when calling transferChunkedAsset.');
                        }
                        if (requestParameters.uploadSessionId === null || requestParameters.uploadSessionId === undefined) {
                            throw new runtime.RequiredError('uploadSessionId', 'Required parameter requestParameters.uploadSessionId was null or undefined when calling transferChunkedAsset.');
                        }
                        if (requestParameters.uploadSection === null || requestParameters.uploadSection === undefined) {
                            throw new runtime.RequiredError('uploadSection', 'Required parameter requestParameters.uploadSection was null or undefined when calling transferChunkedAsset.');
                        }
                        if (requestParameters.media === null || requestParameters.media === undefined) {
                            throw new runtime.RequiredError('media', 'Required parameter requestParameters.media was null or undefined when calling transferChunkedAsset.');
                        }
                        if (requestParameters.assetType === null || requestParameters.assetType === undefined) {
                            throw new runtime.RequiredError('assetType', 'Required parameter requestParameters.assetType was null or undefined when calling transferChunkedAsset.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        consumes = [
                            { contentType: 'multipart/form-data' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        // use FormData to transmit files using content-type "multipart/form-data"
                        useForm = canConsumeForm;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.uploadSessionId !== undefined) {
                            formParams.append('upload_session_id', requestParameters.uploadSessionId);
                        }
                        if (requestParameters.uploadSection !== undefined) {
                            formParams.append('upload_section', requestParameters.uploadSection);
                        }
                        if (requestParameters.media !== undefined) {
                            formParams.append('media', requestParameters.media);
                        }
                        if (requestParameters.assetType !== undefined) {
                            formParams.append('asset_type', new Blob([JSON.stringify((0, index_1.AssetTypeToJSON)(requestParameters.assetType))], { type: "application/json", }));
                        }
                        return [4 /*yield*/, this.request({
                                path: "/ad_accounts/{ad_account_id}/assets/{asset_id}/chunked_upload/transfer".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("asset_id", "}"), encodeURIComponent(String(requestParameters.assetId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.TransferChunkedAssetResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Continues the upload session of a chunked asset by transferring one section of binary media data. Supports uploads of file chunks up to 20MB in size. Asset type can be either image, audio, or video.
     * Transfer Chunked Asset
     */
    AssetsApi.prototype.transferChunkedAsset = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.transferChunkedAssetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates the given existing asset.
     * Update Asset
     */
    AssetsApi.prototype.updateAssetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling updateAsset.');
                        }
                        if (requestParameters.assetId === null || requestParameters.assetId === undefined) {
                            throw new runtime.RequiredError('assetId', 'Required parameter requestParameters.assetId was null or undefined when calling updateAsset.');
                        }
                        if (requestParameters.updateAssetRequest === null || requestParameters.updateAssetRequest === undefined) {
                            throw new runtime.RequiredError('updateAssetRequest', 'Required parameter requestParameters.updateAssetRequest was null or undefined when calling updateAsset.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/assets/{asset_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("asset_id", "}"), encodeURIComponent(String(requestParameters.assetId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.UpdateAssetRequestToJSON)(requestParameters.updateAssetRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AssetResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates the given existing asset.
     * Update Asset
     */
    AssetsApi.prototype.updateAsset = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateAssetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Uploads an asset to storage and returns asset metadata. Supports uploads of files up to 20MB in size. Asset type can be either image, audio, or video. See [here](https://ads.spotify.com/en-US/ad-experiences/audio-ads-specs/) for detailed list of requirements for audio assets and [here](https://ads.spotify.com/en-US/ad-experiences/video-takeover-ad-specs/) for video assets.
     * Upload Asset
     */
    AssetsApi.prototype.uploadAssetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, consumes, canConsumeForm, formParams, useForm, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling uploadAsset.');
                        }
                        if (requestParameters.assetId === null || requestParameters.assetId === undefined) {
                            throw new runtime.RequiredError('assetId', 'Required parameter requestParameters.assetId was null or undefined when calling uploadAsset.');
                        }
                        if (requestParameters.media === null || requestParameters.media === undefined) {
                            throw new runtime.RequiredError('media', 'Required parameter requestParameters.media was null or undefined when calling uploadAsset.');
                        }
                        if (requestParameters.assetType === null || requestParameters.assetType === undefined) {
                            throw new runtime.RequiredError('assetType', 'Required parameter requestParameters.assetType was null or undefined when calling uploadAsset.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        consumes = [
                            { contentType: 'multipart/form-data' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        // use FormData to transmit files using content-type "multipart/form-data"
                        useForm = canConsumeForm;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.media !== undefined) {
                            formParams.append('media', requestParameters.media);
                        }
                        if (requestParameters.assetType !== undefined) {
                            formParams.append('asset_type', new Blob([JSON.stringify((0, index_1.AssetTypeToJSON)(requestParameters.assetType))], { type: "application/json", }));
                        }
                        return [4 /*yield*/, this.request({
                                path: "/ad_accounts/{ad_account_id}/assets/{asset_id}/upload".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("asset_id", "}"), encodeURIComponent(String(requestParameters.assetId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AssetResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Uploads an asset to storage and returns asset metadata. Supports uploads of files up to 20MB in size. Asset type can be either image, audio, or video. See [here](https://ads.spotify.com/en-US/ad-experiences/audio-ads-specs/) for detailed list of requirements for audio assets and [here](https://ads.spotify.com/en-US/ad-experiences/video-takeover-ad-specs/) for video assets.
     * Upload Asset
     */
    AssetsApi.prototype.uploadAsset = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.uploadAssetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AssetsApi;
}(runtime.BaseAPI));
exports.AssetsApi = AssetsApi;
